import NavbarEnum from '../enumerators/navbar.enum'

export default class NavbarComponent {
    constructor() {
        NavbarComponent.sticky()
        NavbarComponent.burger()
        NavbarComponent.lang()
    }

    static sticky() {
        let lastScrollTop = 0
        let stateOnTop = true
        const offset = 50
        const offsetOnScroll = 50
        const navbar = $(NavbarEnum.NAVBAR)
        const header = $(NavbarEnum.HEADER)
        const headerOffset = header.outerHeight() - 100

        if (!$(NavbarEnum.BODY).hasClass('navbar-disable-sticky')) {
            $(window).on('load scroll', function () {
                const scrollTop = $(this).scrollTop()
                let full = false

                //Hidden comportment
                if (
                    $(NavbarEnum.BODY).hasClass('home') &&
                    window.matchMedia('(max-width: 1000px)').matches
                ) {
                    if (scrollTop > headerOffset + 150) {
                        if (scrollTop >= lastScrollTop && scrollTop > navbar.outerHeight()) {
                            $('body').addClass('header-is-hidden')
                        } else {
                            $('body').removeClass('header-is-hidden')
                        }
                    }
                } else {
                    if (scrollTop >= lastScrollTop && scrollTop > navbar.outerHeight()) {
                        $('body').addClass('header-is-hidden')
                    } else {
                        $('body').removeClass('header-is-hidden')
                    }
                }

                // Detect if header is on banner/video mode
                if ($('body.has-banner').length > 0) {
                    full = true
                }

                lastScrollTop = scrollTop

                if (
                    $(NavbarEnum.BODY).hasClass('home') &&
                    $(NavbarEnum.BODY).hasClass('has-banner') &&
                    window.matchMedia('(max-width: 1000px)').matches
                ) {
                    if (scrollTop > headerOffset) {
                        stateOnTop = false
                        navbar.removeClass('navbar--ontop')
                        navbar.addClass('navbar--onscroll')
                        if (full === true) {
                            NavbarComponent.changeLogoColor('classic')
                        }
                    } else if (scrollTop < headerOffset) {
                        navbar.removeClass('navbar--onscroll')
                        navbar.addClass('navbar--ontop')
                        if (full === true) {
                            NavbarComponent.changeLogoColor('banner')
                        }
                    }
                } else {
                    if (scrollTop > offset && stateOnTop === true) {
                        stateOnTop = false
                        navbar.removeClass('navbar--ontop')
                        navbar.addClass('navbar--onscroll')
                        if (full === true) {
                            NavbarComponent.changeLogoColor('classic')
                        }
                    } else if (scrollTop < offsetOnScroll && stateOnTop === false) {
                        stateOnTop = true
                        navbar.removeClass('navbar--onscroll')
                        navbar.addClass('navbar--ontop')
                        if (full === true) {
                            NavbarComponent.changeLogoColor('banner')
                        }
                    }
                }
            })
        }
    }

    static changeLogoColor(color) {
        const logoBanner = IRISCollectionCustomer.imageLogoBanner
        const logoClassic = IRISCollectionCustomer.imageLogo
        const logoColor = IRISCollectionCustomer.imageLogoColor

        if (color === 'banner') {
            $(NavbarEnum.LOGO).attr('src', logoBanner)
        } else if (color === 'classic') {
            $(NavbarEnum.LOGO).attr('src', logoClassic)
        } else if (color === 'color') {
            $(NavbarEnum.LOGO).attr('src', logoColor)
        }
    }

    static burger() {
        //Open/Close menu
        $(NavbarEnum.BURGER_MENU_TRIGGER).on('click', () => {
            $(NavbarEnum.BURGER_SUBMENU).removeClass('submenu-open')
            $(NavbarEnum.BODY).removeClass('submenu-open')
            $(NavbarEnum.BODY).toggleClass('menu-open')

            if ($(NavbarEnum.BODY).hasClass('menu-open')) {
                setTimeout(() => {
                    NavbarComponent.changeLogoColor('color')
                }, 100)
            } else {
                if (
                    $('.navbar--onscroll').length > 0 ||
                    ($('.navbar--ontop').length > 0 && !$(NavbarEnum.BODY).hasClass('has-banner'))
                ) {
                    NavbarComponent.changeLogoColor('classic')
                } else {
                    NavbarComponent.changeLogoColor('banner')
                }
            }
        })

        //Open/Close submenu
        $(NavbarEnum.BURGER_MENU_MORE).on('click', function () {
            $(NavbarEnum.BODY).toggleClass('submenu-open')
            $(this).next(NavbarEnum.BURGER_SUBMENU).toggleClass('submenu-open')
        })

        $(NavbarEnum.BURGER_MENU_PREV).on('click', (e) => {
            e.preventDefault()
            $(NavbarEnum.BODY).removeClass('submenu-open')
            $(NavbarEnum.BURGER_SUBMENU).removeClass('submenu-open')
        })
    }

    static lang() {
        // Switch current language
        $(document).on('click', `${NavbarEnum.BURGER_LANG_SWITCHER_LIST} a`, function () {
            $(NavbarEnum.BURGER_LANG_SWITCHER_TRIGGER).text($(this).text())
            $(NavbarEnum.BURGER_LANG_SWITCHER_LIST).removeClass('lang-switch__list--open')
        })

        // Open
        $(NavbarEnum.BURGER_LANG_SWITCHER_TRIGGER).on('click', () => {
            $(NavbarEnum.BURGER_LANG_SWITCHER_LIST).toggleClass('lang-switch__list--open')
        })

        // Close
        $(window).on('load scroll', () => {
            if ($('body').hasClass('header-is-hidden')) {
                $(NavbarEnum.BURGER_LANG_SWITCHER_LIST).removeClass('lang-switch__list--open')
            }
        })

        $(document).on('click', (e) => {
            if (
                !$(NavbarEnum.BURGER_LANG_SWITCHER).is(e.target) &&
                $(NavbarEnum.BURGER_LANG_SWITCHER).has(e.target).length === 0
            ) {
                $(NavbarEnum.BURGER_LANG_SWITCHER_LIST).removeClass('lang-switch__list--open')
            }
        })
    }
}
